import copy from "copy-to-clipboard";
import React, { isValidElement } from "react";
/**
 * 操作DOM相关的Utils
 */

/**
 * 选中当前html element
 */
export function select<T extends HTMLElement>(element: T) {
    if ((element && element.innerText.length === 0) || !element) return;

    element.focus();

    const range = document.createRange();

    range.selectNodeContents(element);

    const selection = window.getSelection();

    selection.removeAllRanges();

    selection.addRange(range);

    return selection;
}

export function copyFromSelection(selection: Selection, filterText?: string) {
    const originalText = selection.toString();

    const text = filterText ? originalText.replace(filterText, "") : originalText;

    copy(text);
}

/** 在当前页面打开下载 */
export function downloadInPage(url: string) {
    if (import.meta.env.VITE_IS_QN) {
        window.open(url, "_blank");

        return;
    }

    const a = document.createElement("a");

    a.href = url;

    a.download = url;

    document.body.appendChild(a);

    a.click();

    setTimeout(() => {
        document.body.removeChild(a);
    }, 20);
}
